import { gql } from 'apollo-boost';

export const organizationsQuery = gql`
    query OrganizationsQuery($input: GdOrganizationsContainerInput!) {
        reqId: getReqId
        organizations(input: $input) {
            permalinkId
            address {
                geoId
                apartment
                city
                country
                street
                metroStationName
                metroStationId
                houseWithBuilding
            }
            cabinetUrl
            profileUrl
            chainId
            companyName
            email
            phone {
                countryCode
                cityCode
                phoneNumber
                extension
            }
            rubric
            statusPublish
            urls
            workTimes {
                daysOfWeek
                endTime {
                    hour
                    minute
                }
                startTime {
                    hour
                    minute
                }
            }
        }
    }
`;
